<template>
  <div class="inner">
    <!--轮播-->
    <div
      id="slideBox"
      class="slideBox"
      @mouseenter="tabStop()"
      @mouseleave="tabPlay()"
    >
      <div class="hd">
        <ul>
          <li
            v-for="(item,index) in tabImg"
            :key="index"
            :class="{on : tabIndex==index}"
            @click="tabTo(index)"
          >{{index+1}}</li>
        </ul>
      </div>
      <div class="bd">
        <ul class="clearfix">
          <transition-group
            name="fade"
            mode="out-in"
          >
            <li
              v-for="(item,index) in tabImg"
              :key="index"
              v-show="index==tabIndex"
            >
              <img :src="getImg(item.img)" />
              <!-- <p>{{item.p}}</p> -->
            </li>
          </transition-group>
        </ul>

      </div>
      <!-- <p>{{tabImg[0].p}}</p> -->

      <!-- 下面是前/后按钮代码，如果不需要删除即可 -->
      <a
        class="prev"
        href="javascript:void(0)"
        @click="lastPage()"
      ></a>
      <a
        class="next"
        href="javascript:void(0)"
        @click="nextPage()"
      ></a>
    </div>
    <!-- 轮播结束 -->
  </div>

</template>

<script>
export default {
  name: "xwqTabPlay",
  data() {
    return {
      tabImg: [
        {
          img: "tab111",
          p:
            "所有神器升阶材料可在“神器升阶包（百中）”中获得，“神器升阶包（百中）”获得途径如下：通关英雄副本后概率掉落、通关量子竞技场6/9/12层掉落。"
        },
        {
          img: "tab222",
          p:
            "所有神器升阶材料可在“神器升阶包（百中）”中获得，“神器升阶包（百中）”获得途径如下：通关英雄副本后概率掉落、通关量子竞技场6/9/12层掉落。"
        },
        {
          img: "tab333",
          p:
            "所有神器升阶材料可在“神器升阶包（百中）”中获得，“神器升阶包（百中）”获得途径如下：通关英雄副本后概率掉落、通关量子竞技场6/9/12层掉落。"
        }
      ],
      tabIndex: 0,
      timer: null
    };
  },
  mounted() {
    this.tabPlay();
  },

  methods: {
    downDown(selector) {
      var anchor = this.$el.querySelector("#" + selector);
      //document.documentElement.scrollTop=anchor.offsetTop;
      anchor.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    getImg: src => require("../assets/img/tabimg/" + src + ".png"),
    tabPlay() {
      let _this = this;
      this.timer = setInterval(function() {
        if (_this.tabIndex < _this.tabImg.length-1) {
          _this.tabIndex++;
        } else if (_this.tabIndex == _this.tabImg.length) {
          _this.tabIndex = 0;
        }
      }, 5000);
    },
    tabStop() {
      clearInterval(this.timer);
    },
    lastPage() {
      this.tabIndex <= 0 ? (this.tabIndex = this.tabImg.length-1) : this.tabIndex--;
    },
    nextPage() {
      this.tabIndex >= this.tabImg.length-1 ? (this.tabIndex = 0) : this.tabIndex++;
    },
    tabTo(i) {
      this.tabIndex = i;
    }
  }
};
</script>

<style scoped>
/*轮播*/
.flag {
  width: 270px;
  height: 20px;
  font-size: 16px;
  color: #00ebff;
  position: absolute;
  left: 15px;
  top: 300px;
}
.slideBox {
  width: 825px;
  height: 501px;
  overflow: hidden;
  margin: 310px auto 0;
  position: relative;
}
.slideBox .hd {
  height: 15px;
  overflow: hidden;
  position: absolute;
  right: 20px;
  bottom: 150px;
  z-index: 1;
}
.slideBox .hd ul {
  overflow: hidden;
  zoom: 1;
  float: left;
}
.slideBox .hd ul li {
  float: left;
  margin-right: 2px;
  width: 15px;
  height: 15px;
  line-height: 14px;
  text-align: center;
  background: #fff;
  cursor: pointer;
}
.slideBox .hd ul li.on {
  background: #f00;
  color: #fff;
}
.slideBox .bd {
  position: relative;
  height: 400px;
  width: 631px;
  margin: 0 auto ;
  overflow: hidden;
}
.slideBox .bd ul {
  width: 2524px;
  position: relative;
}
.slideBox .bd li {
  zoom: 1;
  vertical-align: middle;
  float: left;
  width: 631px;
}
.slideBox .bd img {
  display: block;
}
.slideBox .bd p {
  text-align: center;
  color: #333;
  font-size: 14px;
  line-height: 20px;
  height: 20px;
  margin-top: 90px;
}

/* 下面是前/后按钮 */
.slideBox .prev {
  position: absolute;
  left: 0;
  top: 55%;
  margin-top: -38px;
  display: block;
  background: url("../assets/img/tableft.png") no-repeat;
  width: 22px;
  height: 77px;

  filter: alpha(opacity=50);
  opacity: 0.5;
}
.slideBox .next {
  position: absolute;
  right: 0;
  top: 55%;
  margin-top: -38px;
  display: block;
  background: url("../assets/img/tabright.png") no-repeat;
  width: 22px;
  height: 77px;

  filter: alpha(opacity=50);
  opacity: 0.5;
}
/*.slideBox .next{ left:auto; right:0; background-position:8px 5px; }*/
.slideBox .prev:hover,
.slideBox .next:hover {
  filter: alpha(opacity=100);
  opacity: 1;
}
.slideBox .prevStop {
  display: none;
}
.slideBox .nextStop {
  display: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>




















// WEBPACK FOOTER //
// src/components/xwqTabPlay.vue